import { Injectable } from '@jack-henry/frontend-utils/di';
import { CompanyAccountModelDto, StpModelDto } from '@treasury/api/channel';
import { StpClient } from '@treasury/api/channel/generated/Stp';
import { CompanyAccount } from '../company/company-account.entity';
import { StopPayment } from './stop-payment.entity';

export const createNullStpFilter = () => ({});

@Injectable()
export class StopPaymentsService {
    constructor(private stopPaymentsClient: StpClient) {}

    public async getAllStopPayments(filters = createNullStpFilter()) {
        const response = await this.stopPaymentsClient.stpGetAll(filters);
        return response.data.map((payment: StpModelDto) => new StopPayment(payment));
    }

    public async searchStopPayments(filters = createNullStpFilter()) {
        const response = await this.stopPaymentsClient.stpSearch(filters);
        return response.data;
    }

    public async approveStopPayment(id: number, comments: string) {
        const response = await this.stopPaymentsClient.stpApprove(id, {
            key: id.toString(),
            value: comments,
            id: 0,
            updatedDate: '',
        });
        return response.data;
    }

    public async batchApproveStopPayments(ids: number[], comments: string) {
        const response = await this.stopPaymentsClient.stpBatchApprove({
            id: 0,
            updatedDate: '',
            lookups: ids.map(id => ({
                key: id.toString(),
                value: comments,
                id: 0,
                updatedDate: '',
            })),
        });
        return response.data;
    }

    public async rejectStopPayment(id: number, comments: string) {
        const response = await this.stopPaymentsClient.stpReject(id, {
            key: id.toString(),
            value: comments,
            id: 0,
            updatedDate: '',
        });
        return response.data;
    }

    public async batchRejectStopPayments(ids: number[], comments: string) {
        const response = await this.stopPaymentsClient.stpBatchReject({
            id: 0,
            updatedDate: '',
            lookups: ids.map(id => ({
                key: id.toString(),
                value: comments,
                id: 0,
                updatedDate: '',
            })),
        });
        return response.data;
    }

    public async cancelStopPayment(id: number, comments: string) {
        const response = await this.stopPaymentsClient.stpCancel(id, {
            key: id as unknown as string, // contract says string but Channel sends a number
            value: comments,
            id: 0,
            updatedDate: '',
        });
        return response.data;
    }

    public async createStopPayment(stopPayment: StopPayment) {
        const response = await this.stopPaymentsClient.stpCreate(stopPayment.toDto());
        return new StopPayment(response.data);
    }

    public async getFilterAccounts() {
        const response = await this.stopPaymentsClient.stpGetFilterAccounts();
        const accounts = response.data as unknown as CompanyAccountModelDto[];
        return accounts.map((account: CompanyAccountModelDto) => new CompanyAccount(account));
    }
}
